import { Tooltip } from 'antd'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import React, { useState } from 'react'
import { StyledTablecount } from '../../../components/TableStyles/TableStylesSqare/JobRolePreview'
import {
  EmptyDivElement,
  EmptySpanElement,
} from '../../../components/UIComponents/CommonStyledComponent'
import PlacementHistoryWithResume from '../../../components/UIComponents/PlacementHistoryWithResume'
import TableJobSearchFilter from '../../../components/UIComponents/TableJobSearchFilter'
import RestrictionsPanel from '../../../components/UIComponents/RestrictionsPanel'
import RightSideArrowIco from '../../../components/icons/RightSideArrowIco'
import DownSideArrowIco from '../../../components/icons/DownSideArrowIco'
import {
  FlexWrap,
  RowNumberData,
} from '../style'
import {
  ActionButton,
  BorderContainer,
  ContainerAlignment,
  FilterTotalCount,
  HeadingText,
} from '../style'
import { toCamelCase } from '../../../utils/helpers'
import ExportTransfer from '../../../components/ExportTransfer'
import ErrorMessage from '../../../utils/ErrorMessage'

export default function JobCandidateList({
  getPreview,
  candidateList,
  onPageChange,
  state,
  objectRef,
  metricsData,
  setState,
  handleHeaderCellClick,
  handleSearch,
  getPlacementHistoryList,
  getStudentPlacedList,
  jobRolePreviewData,
  getJobRolePreview,
  isLoadingState,
  categorayFilter,
  exportCandidate,
  getExportFiledData,
  params,
  instituteCampusId,
  status,
  downlaodData,
  instituteDetails
}) {
  const [studentId, setStudentId] = useState(null)
  const [isOpenHistory, setIsOpenHistory] = useState(false)
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  // Carries the role-scoped cvUrl/isSystemResume off the clicked row — the
  // resume drawer's own fetch (getPreview) hits the generic student endpoint,
  // which has no per-role resume info.
  const [resumeMeta, setResumeMeta] = useState(null)
  const handleNameClick = async data => {
    setStudentId(data?.id)
    setResumeMeta({ cvUrl: data?.cvUrl, isSystemResume: data?.isSystemResume })
    setIsOpenHistory(true)
  }
  const exportColumns = [
    {
      dataIndex: 'title',
      title: 'Name',
    },
  ]

  const columns = [
    {
      title: 'Applied students',
      dataIndex: 'applied_students',
      className:
        state.selectedIndex === 3 ? 'selected-row' : 'candidate-list-cell',
      key: 3,
      width: '135px',
      align: 'Center',

      onHeaderCell: column => {
        return {
          onClick: () => {
            handleHeaderCellClick(column.key, 'APPLIED')
          },
        }
      },
      render: (text, record, index) => {
        return (
          <EmptyDivElement
            className={`${
              state.selectedIndex === 3
                ? 'selected-row'
                : 'candidate-list-count'
            }`}
            style={{
              cursor: 'pointer',
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => handleHeaderCellClick(3, 'APPLIED')}
          >
            {isLoadingState ? 0 : metricsData?.applied ?? 0}
          </EmptyDivElement>
        )
      },
    },

    {
      title: 'moved to evaluation process',
      dataIndex: 'moved_to_evaluation_process',
      className:
        state.selectedIndex === 4 ? 'selected-row' : 'candidate-list-cell',
      key: 4,
      width: '135px',
      align: 'Center',

      onHeaderCell: column => {
        return {
          onClick: () => {
            handleHeaderCellClick(column.key, 'MOVED_EVALUATION_PROCESS')
          },
        }
      },
      render: (text, record, index) => {
        return (
          <EmptyDivElement
            className={`${
              state.selectedIndex === 4
                ? 'selected-row'
                : 'candidate-list-count'
            }`}
            style={{
              cursor: 'pointer',
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => handleHeaderCellClick(4, 'MOVED_EVALUATION_PROCESS ')}
          >
            {isLoadingState ? 0 : metricsData?.movedToEvaluation ?? 0}
          </EmptyDivElement>
        )
      },
    },

    ...(categorayFilter === 'PLACEMENT'
      ? [
          {
            title: ' offered ',
            dataIndex: 'restricted_students',
            className:
              state.selectedIndex === 6
                ? 'selected-row'
                : 'candidate-list-cell',
            width: '135px',
            onHeaderCell: column => {
              return {
                onClick: () => {
                  handleHeaderCellClick(column.key, 'INTENT_TO_OFFER')
                },
              }
            },
            align: 'Center',
            key: 6,

            render: (text, record, index) => {
              return (
                <EmptyDivElement
                  className={`${
                    state.selectedIndex === 6
                      ? 'selected-row'
                      : 'candidate-list-count'
                  }`}
                  style={{
                    cursor: 'pointer',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  onClick={() => handleHeaderCellClick(6, 'INTENT_TO_OFFER ')}
                >
                  {isLoadingState ? 0 : metricsData?.offered ?? 0}
                </EmptyDivElement>
              )
            },
          },
        ]
      : []),

    {
      title: 'hired',
      dataIndex: 'hired_tabs',
      className:
        state.selectedIndex === 5 ? 'selected-row' : 'candidate-list-cell',
      key: 5,
      width: '135px',
      align: 'Center',

      onHeaderCell: column => {
        return {
          onClick: () => {
            handleHeaderCellClick(column.key, 'JOINED')
          },
        }
      },
      render: (text, record, index) => {
        return (
          <EmptyDivElement
            className={`${
              state.selectedIndex === 5
                ? 'selected-row'
                : 'candidate-list-count'
            }`}
            style={{
              cursor: 'pointer',
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => handleHeaderCellClick(5, 'JOINED')}
          >
            {isLoadingState ? 0 : metricsData?.hired ?? 0}
          </EmptyDivElement>
        )
      },
    },
  ]
  const [selectedKeys, setSelectedKeys] = useState([])
  const [targetKeys, setTargetKeys] = useState([])
  const [disabled, setDisabled] = useState(false)
  const [transfer, setTransfer] = useState(false)
  const [exportType, setExportType] = useState('')
  const [exportData, setData] = useState([])
    const handleExportType = value => {
      if (exportType == value) {
        setExportType('')
      } else {
        setExportType(value)
      }
  }
    const [exportLoading, setExportLoading] = useState(false)
  
    const handleExportClick = async () => {
      setExportLoading(true)
      try {
        let payload = {
          downloadList: selectedKeys.map(item => item.title),
          status:status
        }
        if (exportType === 'xlsx') {
          try {
            const blob = await exportCandidate(
              params.roleId,
              exportType,
              payload
            )
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = url
            const statusTilte = downlaodData == 6 ? 'ELIGIBLE' : status
            if (categorayFilter == 'PLACEMENT') {
              link.setAttribute(
                'download',
                `${
                  jobRolePreviewData?.tittle +
                  '_' +
                  statusTilte +
                  '' +
                  (downlaodData === 1
                    ? '(UNRESTRICTED)'
                    : downlaodData === 6
                    ? '(RESTRICTED)'
                    : '') +
                  '_STUDENTS.xlsx'
                }`
              )
            } else {
              link.setAttribute(
                'download',
                `${jobRolePreviewData?.tittle + '_' + status + '_STUDENTS.xlsx'}`
              )
            }
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
  
            setExportLoading(false)
            handleTransferClick(false)
          } catch (error) {
            setExportLoading(false)
            ErrorMessage(error)
          } 
        } else if (exportType === 'googlesheet') {
          try {
            const response = await exportCandidate(
              params.roleId,
              exportType,
              payload
            )
            window.open(response?.data?.url, '_blank')
            setExportLoading(false)
            handleTransferClick(false)
          } catch (error) {
            setExportLoading(false)
            ErrorMessage(error)
          }
        } else {
          try {
            const blob = await exportCandidate(
              params.roleId,
              exportType,
              payload
            )
            const url = window.URL.createObjectURL(
              new Blob([blob], { type: 'text/csv' })
            )
            const link = document.createElement('a')
            const statusTilte = downlaodData == 6 ? 'ELIGIBLE' : status
            link.href = url
            link.setAttribute(
              'download',
              `${jobRolePreviewData?.tittle + '_' + status + '_STUDENTS.csv'}`
            )
            if (categorayFilter == 'PLACEMENT') {
              link.setAttribute(
                'download',
                `${
                  jobRolePreviewData?.tittle +
                  '_' +
                  statusTilte +
                  '' +
                  (downlaodData === 1
                    ? '(UNRESTRICTED)'
                    : downlaodData === 6
                    ? '(RESTRICTED)'
                    : '') +
                  '_STUDENTS.csv'
                }`
              )
            } else {
              link.setAttribute(
                'download',
                `${jobRolePreviewData?.tittle + '_' + status + '_STUDENTS.csv'}`
              )
            }
  
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            handleTransferClick(false)
  
            setExportLoading(false)
          } catch (error) {
            setExportLoading(false)
            ErrorMessage(error)
          }
        }
      } catch (error) {
        ErrorMessage(error)
      }
    }
  const data = [
    {
      eligible_students: 300,
      ineligible_students: 40,
      applied_students: 50,
      missed_students: 50,
      placed_students: 30,
    },
  ]

  const candidateCols = [
    {
      title: 'Student Names',
      dataIndex: 'firstName',
      key: 'role',
      align: 'left',

      render: (_, candidateData) => {
        let name = candidateData?.firstName + ' ' + candidateData?.lastName

        return (
          <FlexWrap alignCenter gap="8px" style={{ width: '180px' }}>
            <RowNumberData style={{ gap: '8px', alignCenter: 'center' }}>
              <AntdAvatar
                style={{
                  verticalAlign: 'middle',
                }}
                src={candidateData?.profileUrl}
                IconName={candidateData?.firstName?.split('')[0]}
                size={35}
              ></AntdAvatar>
              <div style={{ width: 'calc(180px - 35px)' }}>
                <Tooltip title={name}>
                  <EmptySpanElement
                    style={{
                      color: 'rgba(50, 73, 215, 1)',
                      fontWeight: 'bold',
                      cursor: 'pointer', // Add cursor pointer
                    }}
                    onClick={() => handleNameClick(candidateData)}
                  >
                    {name ?? ''}
                  </EmptySpanElement>
                </Tooltip>
                <p style={{ color: '#bfbfbf', margin: 0 }}>
                  {candidateData?.uniRollNo ?? ''}
                </p>
              </div>
            </RowNumberData>
          </FlexWrap>
        )
      },
    },
    {
      title: 'Contact',
      dataIndex: 'phoneNumber',

      key: 'company',
      align: 'left',

      render: (_, candidateDetails) => (
        <RowNumberData>
          <div
            style={{
              width: '90%',
            }}
          >
            <div>{candidateDetails?.phoneNumber ?? ''}</div>
            <Tooltip title={candidateDetails?.primaryEmail}>
              <div
                style={{
                  textWrap: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textTransform: 'initial',
                }}
              >
                {candidateDetails?.primaryEmail ?? ''}
              </div>
            </Tooltip>
          </div>
        </RowNumberData>
      ),
    },

    {
      title: 'Degree & Department',
      dataIndex: 'degree',
      key: 'eligibleCandidates',
      render: (_, candidateEduDetails) => {
        const isExpandable = state?.candidateStatus === 'RESTRICTED';
        const recordKey = candidateEduDetails.id || candidateEduDetails._id || candidateEduDetails.uniRollNo || JSON.stringify(candidateEduDetails);
        const isExpanded = expandedRowKeys.includes(recordKey);
        
        return (
          <RowNumberData style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div
              style={{
                width: isExpandable ? 'calc(100% - 30px)' : '100%',
              }}
            >
              <div>{toCamelCase(candidateEduDetails?.shortForm ?? '')}</div>
              <Tooltip
                title={`${toCamelCase(candidateEduDetails?.degree)} ${toCamelCase(
                  candidateEduDetails?.department
                )}`}
              >
                <div
                  style={{
                    textWrap: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textTransform: 'initial',
                  }}
                >
                  {toCamelCase(candidateEduDetails?.department ?? '')}
                </div>
              </Tooltip>
            </div>
            {isExpandable && (
  <div 
    style={{ 
      cursor: 'pointer', 
      width: '24px', 
      display: 'flex', 
      alignItems: 'center',
      marginRight: '6px',
      marginLeft: '10px',
    }} 
    onClick={(e) => {
      e.stopPropagation();
      const key = recordKey;
      if (expandedRowKeys.includes(key)) {
        // Collapse the row
        setExpandedRowKeys([]);
      } else {
        // Expand only this row, collapse others
        setExpandedRowKeys([key]);
      }
    }}
  >
    {isExpanded ? <DownSideArrowIco /> : <RightSideArrowIco />}
  </div>
)}

          </RowNumberData>
        );
      },
    },

  ]
  const handleTransferClick = async isOpen => {
    try {
      if (isOpen) {
        let fieldDatas = await getExportFiledData()
        if (jobRolePreviewData?.applicationFormTemplate) {
          fieldDatas = ['Form Responses', ...fieldDatas]
        }
        fieldDatas = fieldDatas.map((item, index) => {
          return {
            key: index,
            title: item,
          }
        })
        setData(fieldDatas)
      } else {
        setData([])
      }
      setSelectedKeys([])
      setExportType('')
      setTargetKeys([])
      setTransfer(isOpen)
    } catch (error) {}
  }
  return (
    <React.Fragment>
      <BorderContainer>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between', 
          justifyItems: 'center',
          alignItems: 'center',
          textAlign: 'center'
        }}>
      <HeadingText >Click to expand</HeadingText>
         <ActionButton
            text={'Export'}
            color="secondary"
            marginBottom= {10}
            onClick={() => handleTransferClick(true)}
          />
          </div>
        <div ref={objectRef}></div>
        <StyledTablecount
          columns={columns}
          dataSource={[metricsData].filter(Boolean)}
          pagination={false}
          className="score_filter_table"
          cellSpacing={'0px'}
          removeHoverEffect
        />

        <FilterTotalCount>
          Showing{' '}
          {10 * state.candidateListPageNo + candidateList?.result?.length} of{' '}
          {candidateList?.count}
        </FilterTotalCount>
        <TableJobSearchFilter
          setSearchValue={value => handleSearch(value)}
          searchValue={state.candidateSearch || ''}
          hideFilter
          customTableHeight={'55px'}
        />
        <StyledTablecount
          columns={candidateCols}
          dataSource={
            isLoadingState
              ? []
              : state?.candidateListLoading
              ? []
              : candidateList?.result || []
          }
          pagination={false}
          rowSelection={false}
          loading={state?.candidateListLoading}
          rowKey={record => record.id || record._id || record.uniRollNo || JSON.stringify(record)}
          expandable={
            state?.candidateStatus === 'RESTRICTED'
              ? {
                  expandedRowKeys: expandedRowKeys,
                  expandedRowRender: (record) => <RestrictionsPanel record={record} roleId={ params.roleId}/>,
                  expandIcon: () => null, // Hide the default plus icon
                  expandIconColumnIndex: -1, // Hide the expand icon column
                  onExpand: (expanded, record) => {
                    const recordKey = record.id || record._id || record.uniRollNo || JSON.stringify(record);
                    if (expanded) {
                      // Set only the currently expanded row
                      setExpandedRowKeys([recordKey]);
                    } else {
                      // Collapse the row
                      setExpandedRowKeys([]);
                    }
                  },
                }
              : undefined
          }
          
        />

        <ContainerAlignment>
          <Pagination
            totalPages={candidateList?.count}
            pageSize={candidateList?.limit}
            onChange={onPageChange}
            current={state.candidateListPageNo + 1}
          />
        </ContainerAlignment>
      </BorderContainer>

      <PlacementHistoryWithResume
        studentId={studentId}
        isOpenHistory={isOpenHistory}
        setIsOpenHistory={setIsOpenHistory}
        getJobRolePreview={getJobRolePreview}
        getStudentPlacedList={getStudentPlacedList}
        getPlacementHistoryList={getPlacementHistoryList}
        getPreview={getPreview}
        roleID={params?.roleId}
        resumeMeta={resumeMeta}
      />
      <ExportTransfer
        open={transfer}
        handleClose={handleTransferClick}
        data={exportData}
        columns={exportColumns}
        disabled={disabled}
        setDisabled={setDisabled}
        targetKeys={targetKeys}
        setTargetKeys={setTargetKeys}
        setSelectedKeys={setSelectedKeys}
        exportType={exportType}
        handleExportType={handleExportType}
        handleExportClick={handleExportClick}
        exportLoading={exportLoading}
        setExportLoading={setExportLoading}
      />
    </React.Fragment>
  )
}
